export default __webpack_public_path__ + "static/media/6N5A3880.a7d599b9.jpg";